import { select, takeEvery } from "redux-saga/effects";
import { selectUid } from "../../reducers/index";
import { firebase } from "../../../utils/alias";
import { dispatchOnValueChange } from "./firebaseEvents";

const articlesRef = uid =>
    firebase
        .database()
        .ref(`articles/userNewsFeeds/${uid}`)
        .orderByChild("score")
        .limitToLast(30);

const getArticlesResponse = articles => {
    return { type: "GET_ARTICLES_RESPONSE", articles };
};

const listenOnArticlesChange = function*() {
    const uid = yield select(selectUid);
    const ref = articlesRef(uid);
    yield dispatchOnValueChange(ref, getArticlesResponse);
};

const watchUserThenListenOnArticles = takeEvery(
    "USER_FOUND",
    listenOnArticlesChange
);

export { watchUserThenListenOnArticles };



// WEBPACK FOOTER //
// ./src/store/sagas/firebaseDataSync/articles.js